import { Action } from '@ngrx/store';
import { Alarm, AlarmFilter, AlarmFilterSettings, AlarmSetting, MeteringPoint } from '@model';

export enum AlarmsActionTypes {
  LoadData = '[Alarms] Load',
  LoadDataSuccess = '[Alarms] Load success',
  LoadDataFail = '[Alarms] Load fail',

  Select = '[Alarms] Select',

  CreateItem = '[Alarms] Create',
  CreateItemSuccess = '[Alarms] Create success',
  CreateItemFail = '[Alarms] Create fail',

  BulkCreateItems = '[Alarms] Bulk Create',
  BulkCreateItemsSuccess = '[Alarms] Bulk Create success',
  BulkCreateItemsFail = '[Alarms] Bulk Create fail',

  CreateItemAndRedirect = '[Alarms] Create and redirect',
  CreateItemAndRedirectSuccess = '[Alarms] Create and redirect success',
  CreateItemAndRedirectFail = '[Alarms] Create and redirect fail',

  UpdateItem = '[Alarms] Update',
  UpdateItemSuccess = '[Alarms] Update success',
  UpdateItemFail = '[Alarms] Update fail',

  RemoveItem = '[Alarms] Remove',
  RemoveItemSuccess = '[Alarms] Remove success',
  RemoveItemFail = '[Alarms] Remove fail',

  BulkRemoveItems = '[Alarms] Bulk Remove',
  BulkRemoveItemsSuccess = '[Alarms] Bulk Remove success',
  BulkRemoveItemsFail = '[Alarms] Bulk Remove fail',

  BulkInactivateItems = '[Alarms] Bulk Inactivate',
  BulkInactivateItemsSuccess = '[Alarms] Bulk Inactivate success',
  BulkInactivateItemsFail = '[Alarms] Bulk Inactivate fail',

  BulkActivateItems = '[Alarms] Bulk Activate',
  BulkActivateItemsSuccess = '[Alarms] Bulk Activate success',
  BulkActivateItemsFail = '[Alarms] Bulk Activate fail',

  RemoveItemAndRedirect = '[Alarms] Remove and redirect',
  RemoveItemAndRedirectSuccess = '[Alarms] Remove and redirect success',
  RemoveItemAndRedirectFail = '[Alarms] Remove and redirect fail',

  UpdateAlarmSettings = '[AlarmSettings] Update',
  UpdateAlarmSettingsSuccess = '[AlarmSettings] Update success',
  UpdateAlarmSettingsFail = '[AlarmSettings] Update fail',

  UpdateAlarmSettingsAndRedirectToAlarms = '[AlarmSettings] Update and redirect to Alarms',
  UpdateAlarmSettingsAndRedirectToAlarmsSuccess = '[AlarmSettings] Update and redirect to Alarms success',
  UpdateAlarmSettingsAndRedirectToAlarmsFail = '[AlarmSettings] Update and redirect to Alarms fail',

  UpdateAlarmSettingsAndRedirect = '[AlarmSettings] Update and redirect',
  UpdateAlarmSettingsAndRedirectSuccess = '[AlarmSettings] Update and redirect success',
  UpdateAlarmSettingsAndRedirectFail = '[AlarmSettings] Update and redirect fail',

  BulkUpdateNotificationChannel = '[NotificationChannel] Bulk Update',
  BulkUpdateNotificationChannelSuccess = '[NotificationChannel] Bulk Update success',
  BulkUpdateNotificationChannelFail = '[NotificationChannel] Bulk Update fail',

  SetSelectedMeteringPoints = '[MeteringPoints] Set Selected',

  ClearData = '[Alarms] Clear data',

  AlarmFilterUpdate = '[AlarmFilter] Update filter',
  AlarmFilterSettingsLoadData = '[AlarmFilterSettings] Load data',
  AlarmFilterSettingsLoadSuccess = '[AlarmFilterSettings] Load success',
  AlarmFilterSettingsLoadFail = '[AlarmFilterSettings] Load fail',
}

export class Load implements Action {
  readonly type = AlarmsActionTypes.LoadData;
  constructor() {}
}
export class LoadSuccess implements Action {
  readonly type = AlarmsActionTypes.LoadDataSuccess;
  constructor(public payload: Alarm[]) {}
}
export class LoadFail implements Action {
  readonly type = AlarmsActionTypes.LoadDataFail;
  constructor(public payload: any) {}
}
export class Select implements Action {
  readonly type = AlarmsActionTypes.Select;
  constructor(public payload: Alarm) {}
}
export class Create implements Action {
  readonly type = AlarmsActionTypes.CreateItem;
  constructor(public payload: Alarm) {}
}
export class CreateSuccess implements Action {
  readonly type = AlarmsActionTypes.CreateItemSuccess;
  constructor(public payload: Alarm) {}
}
export class CreateFail implements Action {
  readonly type = AlarmsActionTypes.CreateItemFail;
  constructor(public payload: any) {}
}
export class BulkCreate implements Action {
  readonly type = AlarmsActionTypes.BulkCreateItems;
  constructor(public payload: Alarm[]) {}
}
export class BulkCreateSuccess implements Action {
  readonly type = AlarmsActionTypes.BulkCreateItemsSuccess;
  constructor(public payload: Alarm[]) {}
}
export class BulkCreateFail implements Action {
  readonly type = AlarmsActionTypes.BulkCreateItemsFail;
  constructor(public payload: any) {}
}
export class CreateAndRedirect implements Action {
  readonly type = AlarmsActionTypes.CreateItemAndRedirect;
  constructor(public payload: Alarm) {}
}
export class CreateAndRedirectSuccess implements Action {
  readonly type = AlarmsActionTypes.CreateItemAndRedirectSuccess;
  constructor(public payload: Alarm) {}
}
export class CreateAndRedirectFail implements Action {
  readonly type = AlarmsActionTypes.CreateItemAndRedirectFail;
  constructor(public payload: any) {}
}
export class Update implements Action {
  readonly type = AlarmsActionTypes.UpdateItem;
  constructor(public payload: Alarm) {}
}
export class UpdateSuccess implements Action {
  readonly type = AlarmsActionTypes.UpdateItemSuccess;
  constructor(public payload: Alarm) {}
}
export class UpdateFail implements Action {
  readonly type = AlarmsActionTypes.UpdateItemFail;
  constructor(public payload: any) {}
}

export class Remove implements Action {
  readonly type = AlarmsActionTypes.RemoveItem;
  constructor(public payload: Alarm) {}
}
export class RemoveSuccess implements Action {
  readonly type = AlarmsActionTypes.RemoveItemSuccess;
  constructor(public payload: Alarm) {}
}
export class RemoveFail implements Action {
  readonly type = AlarmsActionTypes.RemoveItemFail;
  constructor(public payload: any) {}
}

// Delete
export class BulkRemove implements Action {
  readonly type = AlarmsActionTypes.BulkRemoveItems;
  constructor(public payload: number[]) {}
}
export class BulkRemoveSuccess implements Action {
  readonly type = AlarmsActionTypes.BulkRemoveItemsSuccess;
  constructor(public payload: number[]) {}
}
export class BulkRemoveFail implements Action {
  readonly type = AlarmsActionTypes.BulkRemoveItemsFail;
  constructor(public payload: any) {}
}

// Inactivate
export class BulkInactivate implements Action {
  readonly type = AlarmsActionTypes.BulkInactivateItems;
  constructor(public payload: Alarm[]) {}
}
export class BulkInactivateSuccess implements Action {
  readonly type = AlarmsActionTypes.BulkInactivateItemsSuccess;
  constructor(public payload: Alarm[]) {}
}
export class BulkInactivateFail implements Action {
  readonly type = AlarmsActionTypes.BulkInactivateItemsFail;
  constructor(public payload: any) {}
}

// Activate
export class BulkActivate implements Action {
  readonly type = AlarmsActionTypes.BulkActivateItems;
  constructor(public payload: Alarm[]) {}
}
export class BulkActivateSuccess implements Action {
  readonly type = AlarmsActionTypes.BulkActivateItemsSuccess;
  constructor(public payload: Alarm[]) {}
}
export class BulkActivateFail implements Action {
  readonly type = AlarmsActionTypes.BulkActivateItemsFail;
  constructor(public payload: any) {}
}

export class RemoveAndRedirect implements Action {
  readonly type = AlarmsActionTypes.RemoveItemAndRedirect;
  constructor(public payload: Alarm) {}
}
export class RemoveAndRedirectSuccess implements Action {
  readonly type = AlarmsActionTypes.RemoveItemAndRedirectSuccess;
  constructor(public payload: Alarm) {}
}
export class RemoveAndRedirectFail implements Action {
  readonly type = AlarmsActionTypes.RemoveItemAndRedirectFail;
  constructor(public payload: any) {}
}
export class UpdateAlarmSettings implements Action {
  readonly type = AlarmsActionTypes.UpdateAlarmSettings;
  constructor(public payload: AlarmSetting[]) {}
}
export class UpdateAlarmSettingsSuccess implements Action {
  readonly type = AlarmsActionTypes.UpdateAlarmSettingsSuccess;
  constructor(public payload: AlarmSetting[]) {}
}
export class UpdateAlarmSettingsFail implements Action {
  readonly type = AlarmsActionTypes.UpdateAlarmSettingsFail;
  constructor(public payload: any) {}
}
export class UpdateAlarmSettingsAndRedirectToAlarms implements Action {
  readonly type = AlarmsActionTypes.UpdateAlarmSettingsAndRedirectToAlarms;
  constructor(public payload: AlarmSetting[]) {}
}
export class UpdateAlarmSettingsAndRedirectToAlarmsSuccess implements Action {
  readonly type = AlarmsActionTypes.UpdateAlarmSettingsAndRedirectToAlarmsSuccess;
  constructor(public payload: AlarmSetting[]) {}
}
export class UpdateAlarmSettingsAndRedirectToAlarmsFail implements Action {
  readonly type = AlarmsActionTypes.UpdateAlarmSettingsAndRedirectToAlarmsFail;
  constructor(public payload: any) {}
}
export class UpdateAlarmSettingsAndRedirect implements Action {
  readonly type = AlarmsActionTypes.UpdateAlarmSettingsAndRedirect;
  constructor(public payload: { alarmSettings: AlarmSetting[]; meteringPointId: number }) {}
}
export class UpdateAlarmSettingsAndRedirectSuccess implements Action {
  readonly type = AlarmsActionTypes.UpdateAlarmSettingsAndRedirectSuccess;
  constructor(public payload: AlarmSetting[]) {}
}
export class UpdateAlarmSettingsAndRedirectFail implements Action {
  readonly type = AlarmsActionTypes.UpdateAlarmSettingsAndRedirectFail;
  constructor(public payload: any) {}
}

// Bulk Update NotificationChannel
export class BulkUpdateNotificationChannel implements Action {
  readonly type = AlarmsActionTypes.BulkUpdateNotificationChannel;
  constructor(public payload: AlarmSetting[]) {}
}
export class BulkUpdateNotificationChannelSuccess implements Action {
  readonly type = AlarmsActionTypes.BulkUpdateNotificationChannelSuccess;
  constructor(public payload: AlarmSetting[]) {}
}
export class BulkUpdateNotificationChannelFail implements Action {
  readonly type = AlarmsActionTypes.BulkUpdateNotificationChannelFail;
  constructor(public payload: any) {}
}

export class SetSelectedMeteringPoints implements Action {
  readonly type = AlarmsActionTypes.SetSelectedMeteringPoints;
  constructor(public payload: MeteringPoint[]) {}
}

export class ClearData implements Action {
  readonly type = AlarmsActionTypes.ClearData;
  constructor() {}
}

export class AlarmFilterUpdate implements Action {
  readonly type = AlarmsActionTypes.AlarmFilterUpdate;
  constructor(public payload: AlarmFilter) {}
}
export class AlarmFilterSettingsLoadData implements Action {
  readonly type = AlarmsActionTypes.AlarmFilterSettingsLoadData;
  constructor() {}
}
export class AlarmFilterSettingsLoadSuccess implements Action {
  readonly type = AlarmsActionTypes.AlarmFilterSettingsLoadSuccess;
  constructor(public payload: AlarmFilterSettings) {}
}
export class AlarmFilterSettingsLoadFail implements Action {
  readonly type = AlarmsActionTypes.AlarmFilterSettingsLoadFail;
  constructor(public payload: any) {}
}


export type AlarmsActions =
  | Load
  | LoadSuccess
  | LoadFail
  | Select
  | Create
  | CreateSuccess
  | CreateFail
  | BulkCreate
  | BulkCreateSuccess
  | BulkCreateFail
  | CreateAndRedirect
  | CreateAndRedirectSuccess
  | CreateAndRedirectFail
  | Update
  | UpdateSuccess
  | UpdateFail
  | Remove
  | RemoveSuccess
  | RemoveFail
  | BulkRemove
  | BulkRemoveSuccess
  | BulkRemoveFail
  | BulkInactivate
  | BulkInactivateSuccess
  | BulkInactivateFail
  | BulkActivate
  | BulkActivateSuccess
  | BulkActivateFail
  | RemoveAndRedirect
  | RemoveAndRedirectSuccess
  | RemoveAndRedirectFail
  | UpdateAlarmSettings
  | UpdateAlarmSettingsSuccess
  | UpdateAlarmSettingsFail
  | UpdateAlarmSettingsAndRedirectToAlarms
  | UpdateAlarmSettingsAndRedirectToAlarmsSuccess
  | UpdateAlarmSettingsAndRedirectToAlarmsFail
  | UpdateAlarmSettingsAndRedirect
  | UpdateAlarmSettingsAndRedirectSuccess
  | UpdateAlarmSettingsAndRedirectFail
  | BulkUpdateNotificationChannel
  | BulkUpdateNotificationChannelSuccess
  | BulkUpdateNotificationChannelFail
  | SetSelectedMeteringPoints
  | ClearData
  | AlarmFilterUpdate
  | AlarmFilterSettingsLoadData
  | AlarmFilterSettingsLoadSuccess
  | AlarmFilterSettingsLoadFail;
